import AccessConnectModal from './access.connect.modal';
import CodeActivateModal from './code.activate.modal';
import { codeItemOf } from './codes.helpers';

// Todos os pontos que conectam acesso usam a escolha configurada na API.
export default function AccessSetupModal({ access, certificate, onConnected, onActivated, ...props }) {
    if (!access.autoActivation)
        return <AccessConnectModal {...props} access={access} certificate={certificate} onConnected={onConnected} />;
    const item = codeItemOf(access, certificate);
    return <CodeActivateModal {...props} item={item} onActivated={onActivated} onReady={onConnected} />;
}
